import React from 'react';
import { Tooltip } from '@material-ui/core';
import Icon from 'Components/UI/Icon';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import PropTypes from 'prop-types';
import moment from 'moment';
import { getTimestampFromString } from 'Helpers/DateTime';

export default function AccountStatus({
  resource, tooltip, accountId: accountIdOverride, lastSync: lastSyncOverride, failed: failedOverride, syncGood: synGoodOverride, isManaged: isManagedOverride, isLinked: isLinkedOverride, ...rest
}) {
  if (resource === null) {
    const nullProps = [accountIdOverride, lastSyncOverride, failedOverride, synGoodOverride, isManagedOverride].filter(p => p === null);
    if (nullProps.length) {
      return null;
    }
  }
  const lastSync = lastSyncOverride !== null ? lastSyncOverride : resource?.attr('lastSync');
  const syncGood = synGoodOverride !== null ? synGoodOverride : resource?.attr('syncStatus') === 'good';
  const failed = failedOverride !== null ? failedOverride : resource?.attr('failedToSync') === 'true' || !syncGood;
  const isManaged = isManagedOverride !== null ? isManagedOverride : resource?.attr('isManaged') === 'true';
  const isLinked = isLinkedOverride !== null ? isLinkedOverride : resource?.attr('externalAccountId') !== undefined || resource?.attr('accountAggregatorMetaId') !== undefined;

  if (!isManaged && !isLinked) {
    return null;
  }

  let LinkIcon = null;
  if (isManaged) {
    LinkIcon = (<Icon
      icon="assetsUnderManagement"
      height={16}
      width={16}
    />);
  } else if (failed) {
    LinkIcon = (<FontAwesome
      icon="exclamation-circle"
      style={{ cursor: 'pointer', color: 'red' }}
    />);
  } else if (syncGood) {
    LinkIcon = (<FontAwesome
      icon="link"
      style={{ cursor: 'pointer' }}
    />);
  }

  const getTitle = () => {
    const updatedAtMoment = moment(getTimestampFromString(lastSync));
    const displayTime = updatedAtMoment.format('M/DD/YY HH:MM:SS');

    if (failed) {
      return (
        <>
          <p> Something wrong with your account. Click for more information </p>
          <p>{lastSync ? `Last synced on ${displayTime}` : null}</p>
        </>
      );
    }
    return lastSync
      ? `Last synced on ${displayTime}`
      : 'Your account is linked';
  };


  const updatedAtMoment = moment(getTimestampFromString(lastSync));
  const label = ` Last synced on ${updatedAtMoment.format('M/DD/YY')}`;

  const Wrapper = tooltip ? Tooltip : React.Fragment;

  const params = { ...rest };

  if (tooltip) {
    params.style = {
      minWidth: 'unset',
      width: '32px',
    };
  }
  return (
    <Wrapper
      title={getTitle()}
      placement="bottom"
      arrow
    >
      <div>
        {LinkIcon}
        {!tooltip && (
          <>
              &nbsp;
              {label}
          </>
        )}
      </div>
    </Wrapper>
  );
}

AccountStatus.propTypes = {
  accountId: PropTypes.string,
  isManaged: PropTypes.bool,
  isLinked: PropTypes.bool,
  syncGood: PropTypes.bool,
  failed: PropTypes.bool,
  lastSync: PropTypes.string,
  resource: PropTypes.object,
  tooltip: PropTypes.bool,
};

AccountStatus.defaultProps = {
  accountId: null,
  isManaged: null,
  isLinked: null,
  syncGood: null,
  failed: null,
  lastSync: null,
  resource: null,
  tooltip: false,
};
